import type { Currency } from '../lib/types';

interface Props {
  value: string;
  onChange: (v: string) => void;
  currency: Currency;
  placeholder?: string;
  autoFocus?: boolean;
}

export default function AmountInput({ value, onChange, currency, placeholder, autoFocus }: Props) {
  return (
    <input
      className="input"
      type="text"
      inputMode="decimal"
      autoComplete="off"
      autoFocus={autoFocus}
      placeholder={placeholder ?? (currency === 'SYP' ? 'e.g. 150000' : 'e.g. 25.00')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
